import { combineReducers } from "@reduxjs/toolkit";

import { mediaCommsGeneralSlice } from "./general";
import { mediaCommRoomsSlice } from "./rooms";

export const mediaCommsReducerMap = {
	mediaCommsGeneral: mediaCommsGeneralSlice.reducer,
	mediaCommRooms: mediaCommRoomsSlice.reducer,
};

const reducers = combineReducers(mediaCommsReducerMap);

export type MediaCommsState = ReturnType<typeof reducers>;
